import type { TOC } from '@ember/component/template-only';
import { PrismBadge, PrismIcon } from '@mylighthouse/prism-ember';

interface HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderAiSuggestionsSignature {
  Args: {
    headerText: string;
    suggestions: string[];
  };
}

const HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderAiSuggestions =
  <template>
    <div class="smart-compset-builder-ai-suggestions">
      <div class="smart-compset-builder-ai-suggestions__header">
        <PrismIcon @color="intelligence" @name="automation" />
        <p class="text-300--regular">{{@headerText}}</p>
      </div>
      <div class="smart-compset-builder-ai-suggestions__body">
        {{#each @suggestions as |suggestion|}}
          <PrismBadge @label={{suggestion}} @type="intelligence" />
        {{/each}}
      </div>
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderAiSuggestionsSignature>;

export default HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderAiSuggestions;
